import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { baseURL } from '../../../../globalUtils/axiosConfig';
import { fetchNpoRegions } from '../../../NpoRegions/redux/actions';
// import BatchUpdateSection from '../batchUpdate';
import FilterSection from '../filterSection';

const FilterAndBatchUpdate = ({
  handleCloseFilter,
  handleCloseBatch,
  handleFilter,
  loading,
  showFilter,
  setShowFilter,
  showBatch,
  setShowBatch,
  handleBatchUpdate,
}) => {
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [dynamicFieldsOptions, setDynamicFieldsOptions] = useState([]);
  const [filterDataFetched, setFilterDataFetched] = useState(false);
  const [users, setUsers] = useState([]);
  const dispatch = useDispatch();

  const { allTemplates } = useSelector(
    (state) => state.templatesManagerReducer
  );

  const fetchUsers = async () => {
    const res = await axios.get(`${baseURL}/api/v1/users/users_except_learner`);
    const { success, data } = res.data;
    if (success) {
      setUsers(data);
    }
  };

  useEffect(() => {
    if (allTemplates.length > 0) {
      let filtered = allTemplates.filter(
        (el) => el.name.toLocaleLowerCase() === 'learner'
      );
      if (filtered.length === 1) {
        const { template_fields } = filtered[0];
        setDynamicFieldsOptions(template_fields);
      }
    }
  }, [allTemplates]);

  useEffect(() => {
    fetchUsers();
    dispatch(fetchNpoRegions());
  }, []);

  const closeHandler = () => {
    handleCloseFilter();
    setSelectedTemplate({});
    // setDynamicFieldsOptions([]);
    setFilterDataFetched(false);
  };

  return (
    <>
      {showFilter && (
        <FilterSection
          handleClose={closeHandler}
          handleFilter={handleFilter}
          selectedTemplate={selectedTemplate}
          setSelectedTemplate={setSelectedTemplate}
          setFilterDataFetched={setFilterDataFetched}
          dynamicFieldsOptions={dynamicFieldsOptions}
          setDynamicFieldsOptions={setDynamicFieldsOptions}
          users={users}
        />
      )}
      {/* {showBatch && (
        <BatchUpdateSection
          handleClose={handleCloseBatch}
          handleFilter={handleBatchUpdate}
          loading={loading}
          selectedTemplate={selectedTemplate}
          setSelectedTemplate={setSelectedTemplate}
          filterDataFetched={filterDataFetched}
          dynamicFieldsOptions={dynamicFieldsOptions}
          setDynamicFieldsOptions={setDynamicFieldsOptions}
        />
      )} */}
    </>
  );
};

export default FilterAndBatchUpdate;
